{
  "cityMap": {
    "products": {
      "paper": {
        "productId": 3511,
        "variations": {
          "small-no-frame": 10759, "medium-no-frame": 10761, "large-no-frame": 10763,
          "small-black": 10760, "medium-black": 10762, "large-black": 10764,
          "small-oak": 27760, "medium-oak": 27761, "large-oak": 27762
        }
      }
    }
  },
  "housewarming": {
    "products": {
      "paper": {
        "productId": 4600,
        "variations": {
          "small-no-frame": 11013, "medium-no-frame": 11015, "large-no-frame": 11017,
          "small-black": 11014, "medium-black": 11016, "large-black": 11018,
          "small-oak": 27777, "medium-oak": 27778, "large-oak": 27779
        }
      }
    }
  },
  "corporateGift": {
    "products": {
      "paper": {
        "productId": 5824,
        "variations": {
          "small-no-frame": 11031, "medium-no-frame": 39362, "large-no-frame": 39360,
          "small-black": 11032, "medium-black": 11037, "large-black": 11041,
          "small-oak": 39365, "medium-oak": 11036, "large-oak": 39361
        }
      }
    }
  },
  "specialLocation": {
    "products": {
      "paper": {
        "productId": 4439,
        "variations": {
          "small-no-frame": 11384, "medium-no-frame": 11390, "large-no-frame": 11399,
          "small-black": 11386, "medium-black": 11394, "large-black": 11403,
          "small-oak": 27789, "medium-oak": 27790, "large-oak": 27791
        }
      }
    }
  },
  "sportsmap": {
    "products": {
      "paper": {
        "productId": 4199,
        "variations": {
          "small-no-frame": 4200, "medium-no-frame": 4202, "large-no-frame": 4204,
          "small-black": 4201, "medium-black": 4203, "large-black": 4657,
          "small-oak": 27808, "medium-oak": 27809, "large-oak": 27810
        }
      }
    }
  },
  "songtext": {
    "products": {
      "paper": {
        "productId": 27942,
        "variations": {
          "small-no-frame": 27947, "medium-no-frame": 27949, "large-no-frame": 27951,
          "small-black": 27948, "medium-black": 27950, "large-black": 27946,
          "small-oak": 27943, "medium-oak": 27944, "large-oak": 27945
        }
      },
      "acryl": {
        "productId": 39555,
        "variations": {
          "xs-no-block": 39557, "small-no-block": 39556,
          "xs-oak": 39559, "small-oak": 39558,
          "xs-black": 39561, "small-black": 39560
        }
      }
    }
  },
  "lovemap": {
    "products": { "paper": { "productId": 3580, "variations": {
      "small-no-frame": 3581, "medium-no-frame": 3582, "large-no-frame": 3583,
      "small-black": 3637, "medium-black": 3638, "large-black": 4658,
      "small-oak": 27805, "medium-oak": 27806, "large-oak": 27807
    } } }
  },
  "date": {
    "products": { "paper": { "productId": 11435, "variations": {
      "small-no-frame": 11437, "medium-no-frame": 11439, "large-no-frame": 11441,
      "small-black": 11438, "medium-black": 11440, "large-black": 11436,
      "small-oak": 27802, "medium-oak": 27803, "large-oak": 27804
    } } }
  },
  "dictionary": {
    "products": { "paper": { "productId": 8901, "variations": {
      "small-no-frame": 8903, "medium-no-frame": 8905, "large-no-frame": 8907,
      "small-black": 8904, "medium-black": 8906, "large-black": 8902,
      "small-oak": 27811, "medium-oak": 27812, "large-oak": 27813
    } } }
  }
}
